import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import Link from '@nubank/nuds-web/components/Link/Link';
import Box from '@nubank/nuds-web/components/Box/Box';
import PropTypes from 'prop-types';

import { maybeFormatPrefixedMessage } from 'utils/i18nUtils';

import FeeDetails from './components/FeeDetails/FeeDetails';

const i18nPrefix = 'FEES_TABLE';

const FEES = [
  'ANNUITY',
  'MAINTENANCE',
  'TED',
  'DEPOSIT',
  'DEBIT',
  'WITHDRAW',
];

function FeesTable({
  feesList,
}) {
  const intl = useIntl();
  const prefixFee = maybeFormatPrefixedMessage(intl, i18nPrefix);

  return (
    <>
      <Box>
        {feesList.map(fee => (
          <FeeDetails
            key={prefixFee(fee)}
            description={prefixFee(fee)}
            value={prefixFee(`${fee}.VALUE`)}
          />
        ))}
      </Box>
      <Box display="flex" paddingTop="0.75rem">
        <Link
          variant="action"
          intlKey="FEES_TABLE.LINK"
          href="https://blog.nubank.com.br/por-que-o-nubank-cobra-pelo-saque-no-debito/"
        />
      </Box>
    </>
  );
}

FeesTable.defaultProps = {
  feesList: FEES,
};

FeesTable.propTypes = {
  feesList: PropTypes.arrayOf(PropTypes.string),
};

export default memo(FeesTable);
